import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { join } from 'lodash';
import Yup from 'yup';
import { GridItem } from '../Grid';
import TextFieldWrapper from './TextFieldWrapper';
import PhoneNumberForm, {
  getPhoneNumberFormValidation,
} from './PhoneNumberForm';

const PRIMARY_PHONE_NUMBER = 'primaryPhoneNumber';
const EMAIL = 'email';

function ContactInfoForm({
  emailRequired,
  paths,
  phoneRequired,
  setFieldValue,
  hasExtension,
  values,
}) {
  return (
    <React.Fragment>
      <GridItem lg={hasExtension ? 6 : 4} xs={12}>
        <PhoneNumberForm
          fieldName={PRIMARY_PHONE_NUMBER}
          hasExtension={hasExtension}
          label="Primary phone number"
          paths={paths}
          phoneRequired={phoneRequired}
          setFieldValue={setFieldValue}
          values={values}
        />
      </GridItem>
      <GridItem lg={hasExtension ? 6 : 4} xs={12}>
        <Field
          component={TextFieldWrapper}
          id={EMAIL}
          label="Email"
          name={join([...paths, EMAIL], '.')}
          paths={[...paths, EMAIL]}
          required={emailRequired}
        />
      </GridItem>
    </React.Fragment>
  );
}

ContactInfoForm.propTypes = {
  setFieldValue: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  emailRequired: PropTypes.bool,
  hasExtension: PropTypes.bool,
  paths: PropTypes.array,
  phoneRequired: PropTypes.bool,
};

const defaultRequired = {
  emailRequired: false,
  phoneRequired: false,
};

ContactInfoForm.defaultProps = {
  hasExtension: false,
  paths: [],
  ...defaultRequired,
};

export default ContactInfoForm;

export function getContactInfoValidation(config = defaultRequired) {
  const emailSchema = Yup.string().email('Please enter a valid email.');

  return {
    [EMAIL]: config.emailRequired
      ? emailSchema.required('Email address is required.')
      : emailSchema,
    ...getPhoneNumberFormValidation({ phoneRequired: config.phoneRequired }),
  };
}



// WEBPACK FOOTER //
// ./src/modules/common/form/ContactInfoForm.js